import React from 'react';
import styled from 'styled-components';
import { ShortBody, SmallSectionHeader } from 'components/Typography';
import { Box, Grid } from '@material-ui/core';

const StyledCaptions = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  &&& {
    line-height: 16px;
    margin-bottom: 0px;
    color: #0075c9;
    margin-left: ${(props) => (props.reverse ? '0px' : '12px')};
    margin-right: ${(props) => (props.reverse ? '12px' : '0px')};
  }
`;

const ItemWrapper = styled(({ reverse, ...otherProps }) => (
  <Box {...otherProps} />
))`
  background-color: #e8f3f8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 40px;
  cursor: pointer;
  margin: 16px;
  &: hover {
    opacity: 0.9;
    background-color: #e8f3f8;
  }
`;

const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;

const SizedGridItem = styled(Grid)`
  && {
    margin-top: 2px;
    max-width: 100%;
  }
`;
export { StyledCaptions, ItemWrapper, SizedSmallSectionHeader, SizedGridItem };
